// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"38":"2511c34c","124":"03edff2f"}[chunkId] + ".chunk.css";
};